import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import Logo from './Logo';
import { AlphaBadge } from '../common';
import { useTheme } from '../../context/ThemeContext';
import './Header.css';
import { useSelector } from 'react-redux';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isDarkMode, toggleTheme } = useTheme();
  const { isAdmin } = useSelector((state) => state.user);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = !isMenuOpen ? 'hidden' : 'auto';
  };

  return (
    <header className="ntb-copilot-header">
      <div className="ntb-copilot-header-content">
        <Link to="/" className="ntb-copilot-logo-link">
          <Logo />
          <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
            NanoTradingCopilot
            <AlphaBadge />
          </Typography>
        </Link>

        <nav className={`ntb-copilot-nav-links ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" onClick={toggleMenu}>Home</Link>
          <Link to="/trading-philosophy" onClick={toggleMenu}>Trading Philosophy</Link>
          <Link to="/pricing" onClick={toggleMenu}>Pricing</Link>
          <Link to="/about" onClick={toggleMenu}>About</Link>
          <Link to="/support" onClick={toggleMenu}>Support</Link>
        </nav>

        <div className={`ntb-copilot-auth-buttons ${isMenuOpen ? 'active' : ''}`}>
          <button
            className="ntb-copilot-theme-toggle"
            onClick={toggleTheme}
            aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {isDarkMode ? <LightModeIcon /> : <DarkModeIcon />}
          </button>
          <Link to="/login" className="ntb-copilot-login-btn" onClick={toggleMenu}>Login</Link>
          <Link to="/pricing" className="ntb-copilot-signup-btn" onClick={toggleMenu}>View Pricing</Link>
        </div>

        <button
          className="ntb-copilot-mobile-menu-btn"
          onClick={toggleMenu}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        >
          {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
        </button>

        {isAdmin && <Link to="/admin" className="ntb-copilot-nav-link">Admin</Link>}
      </div>
    </header>
  );
};

export default Header; 